import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Mensaje mostrado cuando la búsqueda no arroja enlaces coincidentes
 */
const GestorEmptySearch = ({ query }) => {
  return (
    <Box
      sx={{
        padding: '24px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E5E9EF',
        borderRadius: '16px',
      }}
    >
      <Typography
        sx={{
          fontSize: '15px',
          color: '#4F5868',
          fontFamily: (theme) => theme.typography.h1.fontFamily,
        }}
      >
        No hay enlaces que coincidan con “{query}”.
      </Typography>
    </Box>
  );
};

export default GestorEmptySearch;
